import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Password = () => {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [failed, setFailed] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [successError, setSuccessError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [isAffiliate, setIsAffiliate] = useState(false)
  const [saveBtn, setSaveBtn] = useState('save-btn')
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = "Forgot password - Can't log in"
  }, [])

  const handleForm = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (email.trim() === '') {
      setError('Enter email or phone number')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else {
      setSaveBtn('btn-disabled')
      setDisabled(true)
      setLoading(true)
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`
      const data = new FormData()
      data.append('email', email)
      data.append('isAffiliate', isAffiliate)
      data.append('query', 'RECOVERPASSWORD')
      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            history.push({
              pathname: '/set-password',
              state: {
                email: email,
                accounttype: response.data.account_type,
                message: response.data.message,
                isAffiliate: response.data.isAffiliate,
                account_name: response.data.account_name,
              },
            })
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('error-login')
          }

          setSaveBtn('save-btn')
          setDisabled(false)
          setLoading(false)
        })
        .catch((error) => {
          setSaveBtn('save-btn')
          setDisabled(false)
          alert(error)
          console.log(error)
          setLoading(false)
        })
    }
    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center w-100 login-screen-container">
          <div className="col-lg-5 col-12 login-container-adjust">
            <div className="log-title text-center">
              <Link to="/">
                <img src={`${API_URL}/karamale.png`} width="170" />
              </Link>
            </div>
            <div className="BoxDashboardContainer w-100">
              <input
                type="text"
                name="email"
                required
                placeholder="Email address or phone number"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
              <div style={{ marginTop: '-0.9rem' }}>
                <input
                  type="checkbox"
                  value={isAffiliate}
                  width={'w-auto'}
                  id="affiliate_box"
                  className="checkbox float-left cursor-pointer"
                  onChange={(e) => setIsAffiliate(isAffiliate ? false : true)}
                />{' '}
                <label
                  htmlFor="affiliate_box"
                  className="ml-2 cursor-pointer"
                  style={{ marginTop: '0.6rem' }}
                >
                  Check if you are an affiliate
                </label>
              </div>
              <div
                className=""
                style={{
                  padding: 10,
                  paddingLeft: 0,
                  paddingTop: 0,
                  paddingBottom: 0,
                  color: 'red',
                }}
              >
                {failed}
              </div>
              <div
                className=""
                style={{
                  padding: 10,
                  paddingLeft: 0,
                  paddingTop: 0,
                  color: 'green',
                }}
              >
                {success}
              </div>
              <button
                onClick={() => handleForm()}
                className={saveBtn + ' w-100 mb-3'}
                disabled={disabled}
              >
                {!loading && <span>Submit</span>}

                {loading && (
                  <span>
                    <ClipLoader
                      color={'grey'}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </span>
                )}
              </button>
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <div className="text-center cancel-btn">Log in</div>
              </Link>

              {/* <div className="horizontal-line mt-4"></div> */}

              {/* <Link to="/codepage">
                <div className="forgotPasswordText text-center">
                  I have the <span>Reset code</span>
                </div>
              </Link> */}
            </div>

            <div className="text-footer text-center">
              If the email or phone is linked to an account, you'll receive an OTP shortly.
            </div>
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default Password
